import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

import {Constants} from '../config/constants.config';
import {ProductViewModel} from '../viewModels/product.viewModel';
import {GetProductsByIdsDTO} from '../dto/getProductsByIds.dto';
import {ProductNutrientViewModel} from '../viewModels/productNutrient.viewModel';
import {AllergyViewModel} from '../../meals/components/viewModels/allergy.viewModel';
import {ProductExternalMealViewModel} from '../viewModels/productExternalMeal.viewModel';
import {
    RecipeListResultViewModalModel,
    RecipeListViewModalModel,
    RecipeViewModalModel,
    RecipeViewModel
} from '../viewModels/recipe.viewModel';
import {RecipeAttributeViewModel} from '../viewModels/recipeAttribute.viewModel';
import {RecipeCategoryViewModel} from '../viewModels/recipeCategory.viewModel';
import {CategoryViewModel, GlobalCategoryViewModel} from '../../meals/components/viewModels/category.viewModel';
import {formatDate} from '../utilities/date.utilities';

@Injectable()
export class ProductsService {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly constants: Constants
    ) {
    }

    getProductsByIds(getProductsByIdsDTO: GetProductsByIdsDTO): Observable<ProductViewModel[]> {
        return this.httpClient.post<ProductViewModel[]>(`${this.constants.apiURL()}/products/`, getProductsByIdsDTO);
    }

    getAllProducts(): Observable<CategoryViewModel[]> {
        return this.httpClient.get<CategoryViewModel[]>(`${this.constants.apiURL()}/products/`);
    }

    getProductAllCategories(): Observable<CategoryViewModel[]> {
        return this.httpClient.get<CategoryViewModel[]>(`${this.constants.apiURL()}/products/categories/`);
    }

    getGlobalCategories(): Observable<GlobalCategoryViewModel[]> {
        return this.httpClient.get<GlobalCategoryViewModel[]>(`${this.constants.apiURL()}/products/categories/global/`);
    }

    getProductsNutrients(): Observable<ProductNutrientViewModel[]> {
        return this.httpClient.get<ProductNutrientViewModel[]>(`${this.constants.apiURL()}/products/nutrients/`);
    }

    getAllergies(): Observable<AllergyViewModel[]> {
        return this.httpClient.get<AllergyViewModel[]>(`${this.constants.apiURL()}/products/allergies/`);
    }

    getExternalMeals(): Observable<ProductExternalMealViewModel[]> {
        return this.httpClient.get<ProductExternalMealViewModel[]>(`${this.constants.apiURL()}/products/external-meals/`);
    }

    getLatestRecipe(): Observable<RecipeViewModalModel> {
        return this.httpClient.get<RecipeViewModalModel>(`${this.constants.apiURL()}/recipes/latest/`);
    }

    getListRecipes(skip: number, categories, attributes, has_video, meal_prep_friendly): Observable<RecipeListResultViewModalModel> {
        return this.httpClient.post<RecipeListResultViewModalModel>(`${this.constants.apiURL()}/recipes/list/`, {
            'categories': categories,
            'attributes': attributes,
            'meal_prep_friendly': meal_prep_friendly,
            'has_video': has_video
        }, {
            params: new HttpParams().set('skip', String(skip))
        });
    }

    getLatestVideoRecipe(): Observable<RecipeViewModel> {
        return this.httpClient.get<RecipeViewModel>(`${this.constants.apiURL()}/videos/latest/`);
    }

    getListVideoRecipes(skip: number): Observable<RecipeViewModel[]> {
        return this.httpClient.get<RecipeViewModel[]>(`${this.constants.apiURL()}/videos/list/`, {
            params: new HttpParams().set('skip', String(skip))
        });
    }

    getRecipesAttributes(): Observable<RecipeAttributeViewModel[]> {
        return this.httpClient.get<RecipeAttributeViewModel[]>(`${this.constants.apiURL()}/recipes/attributes/`);
    }

    getRecipeAllCategories(): Observable<RecipeCategoryViewModel[]> {
        return this.httpClient.get<RecipeCategoryViewModel[]>(`${this.constants.apiURL()}/recipes/categories/all/`);
    }

    getRecipesText(date: string = formatDate(new Date(), this.constants.defaultAPIDateFormat)): Observable<RecipeViewModalModel[]> {
        return this.httpClient.get<RecipeViewModalModel[]>(`${this.constants.apiURL()}/recipes/text/${date}/`);
    }

}
